import React, { Component } from "react";
import Techinsert from "./Techinsert";
import Portforlioinsert from "./Portfolioinsert";
import { BrowserRouter as Router, Route } from "react-router-dom";

class Documentpane extends Component {
  render() {
    return (
      <div>
        <Router>
          <Route
            path="/"
            render={() => (
              <React.Fragment>
                <Techinsert />
                <Portforlioinsert />
              </React.Fragment>
            )}
          />
        </Router>
      </div>
    );
  }
}

export default Documentpane;



// WEBPACK FOOTER //
// ./src/components/Documentpane.js